<template>
  <div ref="seccionPadresRef" class="seccion-invitacion-container">
    
    <!-- CAPA DE FONDO: MARIPOSAS ANIMADAS CON GSAP Y CSS -->
    <div class="mariposas-layer">
      <img
        v-for="(mariposa, index) in mariposas"
        :key="index"
        :ref="el => mariposaRefs[index] = el"
        src="@/assets/1942483b2f7cb66952d677750fe78c1d.png"
        alt="Butterfly"
        class="mariposa-img"
        :style="mariposa.estiloInicial"
      >
    </div>

    <div class="overlay-padres">
      
      <!-- SECCIÓN DECORATIVA SUPERIOR: Corona y Moño -->
      <div ref="graphicsHeaderRef" class="header-graphics-wrapper">
        
        <!-- Contenedor del moño corregido y perfectamente centrado -->
        <div class="monio-full-width-wrapper">
          <img
            src="@/assets/monio.png"
            alt="Red Bow"
            class="monio-header-img"
          >
        </div>
      </div>

      <!-- 🎭 MÁSCARA COLOCADA ABAJO DEL MOÑO (SEGUNDO LUGAR EN LA SECUENCIA) -->
      <div ref="mascaraWrapperRef" class="mascara-sub-monio-wrapper">
        <img
          src="@/assets/coronaa.png"
          alt="Mask"
          class="mascara-sub-monio-img"
        >
      </div>

      <!-- SECCIÓN TEXTO EMOCIONAL -->
      <div ref="textoPoemaRef" class="texto-poema-container">
        <p class="poema-linea">
There are unforgettable moments that are treasured in the heart forever, which is why I would love for you to share this special day with me.      <br>  <br>  </p>
        <h2 class="mis-xv-title">My<span class="letra-especial1"> &nbsp; Sweet 15</span></h2>
        <p class="bendicion-linea"><br>
          My parents:
        </p>
      </div>

      <!-- SECCIÓN PADRES Y VERSÍCULO -->
      <div ref="padresContainerRef" class="padres-container">
        <div class="nombre-padre">
  <span class="letra-great-vibes">R</span>ene Alvarez
</div>
        <img src="@/assets/ampersand.png" alt="And" class="ampersand-img" />
        <div class="nombre-padre">Connie Talavera  </div>

        <!-- Versículo Bíblico / Frase y Foto interactiva 
        <div class="versiculo-container">
          <p class="versiculo-texto"><br><br>The little princess who once dreamed of her fairytale, today celebrates her Sweet 15.  
          </p>
-->
          <!-- FOTO DE CHIQUITA CON CLIC PARA AMPLIAR 
          <div class="contenedor-foto-chiquita" @click="abrirZoom">
            <div class="marco-polaroid">
              <img src="@/assets/ChatGPT Image 15 sept 2026, 02_01_17.png" alt="Little princess" class="foto-chiquita" />
              <div class="zoom-indicador">
                <span class="icono-lupa"></span> Tap to enlarge
              </div>
            </div>
          </div>

          <span class="versiculo-ref"></span>
        </div>-->
      </div>

    </div>

    <!-- MODAL DE ZOOM / PANTALLA COMPLETA 
    <transition name="fade-modal">
      <div v-if="fotoAmpliada" class="modal-zoom-overlay" @click="cerrarZoom">
        <div class="modal-contenido" @click.stop>
          <button class="btn-cerrar" @click="cerrarZoom">&times;</button>
          <img src="@/assets/ChatGPT Image 15 sept 2026, 02_01_17.png" alt="Little princess enlarged" class="foto-zoom" />
        </div>
      </div>
    </transition>-->

    <!-- REFERENCIA INFERIOR DERECHA (NÚMEROS 6:25)x
    <div ref="refEsquinaRef" class="referencia-esquina-derecha">
      Numbers 6:25
    </div>-->
  </div>
</template>
<script>
import { ref, onMounted } from 'vue'
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export default {
  name: 'SeccionPadresPadrinos',
  setup() {
    const seccionPadresRef = ref(null)
    const graphicsHeaderRef = ref(null)
    const mascaraWrapperRef = ref(null)
    const textoPoemaRef = ref(null)
    const padresContainerRef = ref(null)
    const refEsquinaRef = ref(null)
    
    const mariposaRefs = ref([])
    const fotoAmpliada = ref(false)

    const abrirZoom = () => {
      fotoAmpliada.value = true
    }

    const cerrarZoom = () => {
      fotoAmpliada.value = false
    }

    // Configuración inicial de posiciones para las mariposas
    const mariposas = [
      { estiloInicial: { top: '0%', left: '6%', width: '68px' } },
      { estiloInicial: { top: '25%', right: '4%', width: '65px' } },
      { estiloInicial: { top: '85%', left: '4%', width: '60px' } },
      { estiloInicial: { top: '93%', right: '6%', width: '66px' } }
    ]

    onMounted(() => {
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: seccionPadresRef.value,
          start: 'top 75%',
          toggleActions: 'play none none none'
        }
      })

      tl.from(graphicsHeaderRef.value, {
        opacity: 0,
        y: -35,
        scale: 0.95,
        duration: 1.1,
        ease: 'power2.out'
      })
      
      .from(mascaraWrapperRef.value, {
        opacity: 0,
        y: -20,
        scale: 0.8,
        duration: 0.8,
        ease: 'back.out(1.5)'
      }, '-=0.4')

      .from(textoPoemaRef.value, {
        opacity: 0,
        y: 30,
        duration: 0.9,
        ease: 'power3.out'
      }, '-=0.4')

      .from(padresContainerRef.value, {
        opacity: 0,
        scale: 0.9,
        y: 25,
        duration: 1,
        ease: 'back.out(1.4)'
      }, '-=0.4')

      .from(refEsquinaRef.value, {
        opacity: 0,
        x: 20,
        duration: 0.8,
        ease: 'power2.out'
      }, '-=0.3')

      mariposaRefs.value.forEach((el, index) => {
        if (!el) return
        gsap.to(el, {
          y: '+=18',
          x: index % 2 === 0 ? '+=10' : '-=10',
          rotation: index % 2 === 0 ? 8 : -8,
          duration: 3 + index * 0.7,
          repeat: -1,
          yoyo: true,
          ease: 'sine.easeInOut'
        })
      })
    })

    return {
      seccionPadresRef,
      graphicsHeaderRef,
      mascaraWrapperRef,
      textoPoemaRef,
      padresContainerRef,
      refEsquinaRef,
      mariposaRefs,
      mariposas,
      fotoAmpliada,
      abrirZoom,
      cerrarZoom
    }
  }
}
</script>

<style scoped>
/* ==========================================
   1. CONTENEDOR PRINCIPAL
   ========================================== */
.seccion-invitacion-container {
  position: relative;
  width: 100%;
  min-height: 90vh;
  background-color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  overflow: hidden;
  margin-top: -50px;
  padding-bottom: -90px;
}

.overlay-padres {
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 2;
}

/* ==========================================
   2. CORONA Y MOÑO
   ========================================== */
.header-graphics-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  margin-bottom: 25px;
  position: relative;
}

.monio-full-width-wrapper {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}

.monio-header-img {
  width: 100%;
  min-width: 100%;
  max-width: none;
  height: auto;
  display: block;
  object-fit: cover;
}

/* ==========================================
   3. TEXTO Y CONTENIDO
   ========================================== */
.texto-poema-container {
  text-align: center;
  margin: 0 auto 25px;
  padding: 0 24px;
  max-width: 550px;
  box-sizing: border-box;
}

.poema-linea {
  font-family: 'Playfair Display', serif;
  font-size: 17px;
  line-height: 1.6;
  color: #9b9a99;
  font-style: italic;
  margin-bottom: 12px;
}

.mis-xv-title {
  font-family: 'ludovica', serif;
  font-size: 44px;
  color: #5999d2;
  font-weight: 500;
  padding-right: 9px !important;
  margin: 10px 0;
  line-height: 1;
}

.bendicion-linea {
  font-family: 'Playfair Display', serif;
  font-size: 15px;
  line-height: 1.5;
  color: #9b9a99;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 1px;
}

/* ==========================================
   4. PADRES Y VERSÍCULO
   ========================================== */
.padres-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  text-align: center;
  padding: 0 20px;
  box-sizing: border-box;
  margin-bottom: 35px;
  margin-top:-30px;
}

.nombre-padre {
  font-family: 'ludovica', serif;
  font-size: 38px;
  color: #5999d2;
  font-weight: 500;
  line-height: 1.5;
}

.ampersand-img {
  width: 40px;
  height: auto;
  margin: 5px 0;
  display: block;
}

.versiculo-container {
  margin-top: 18px;
  max-width: 480px;
  padding: 0 15px;
}

.versiculo-texto {
  font-family: 'Playfair Display', serif;
  font-size: 18px !important;
  line-height: 1.6;
  color: #9b9a99;
  font-style: italic;
  margin-bottom: 15px;
}

/* ==========================================
   ESTILOS PARA LA FOTO INTERACTIVA
   ========================================== */
.contenedor-foto-chiquita {
  width: 100%;
  max-width: 220px;
  margin: 15px auto 20px auto;
  cursor: pointer;
  position: relative;
}

.marco-polaroid {
  background: #ffffff;
  padding: 10px 10px 28px 10px;
  border-radius: 10px;
  box-shadow: 
    0 10px 25px rgba(0, 0, 0, 0.1),
    0 2px 5px rgba(0, 0, 0, 0.03);
  transform: rotate(-1deg);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  position: relative;
}

.marco-polaroid:hover {
  transform: rotate(0deg) scale(1.03);
  box-shadow: 0 15px 30px rgba(238, 147, 189, 0.25);
}

.foto-chiquita {
  width: 100%;
  height: 190px;
  object-fit: cover;
  display: block;
  border-radius: 4px;
  margin-bottom: -0px;
}

/* Indicador sutil para invitar a dar clic */
.zoom-indicador {
  position: absolute;
  bottom: 8px;
  left: 0;
  width: 100%;
  text-align: center;
  font-family: 'Playfair Display', serif;
  font-size: 11px;
  color: #ee93bd;
  letter-spacing: 0.5px;
}

/* ==========================================
   MODAL DE ZOOM (PANTALLA COMPLETA)
   ========================================== */
.modal-zoom-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.85);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  backdrop-filter: blur(5px);
  padding: 20px;
  box-sizing: border-box;
}

.modal-contenido {
  position: relative;
  background: #fff;
  padding: 15px 15px 40px 15px;
  border-radius: 14px;
  max-width: 90vw;
  max-height: 85vh;
  box-shadow: 0 20px 40px rgba(0,0,0,0.4);
  animation: zoomInModal 0.3s ease;
}

.foto-zoom {
  max-width: 100%;
  max-height: 70vh;
  object-fit: contain;
  display: block;
  border-radius: 6px;
}

.btn-cerrar {
  position: absolute;
  top: -15px;
  right: -15px;
  background: #ee93bd;
  color: white;
  border: none;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  font-size: 22px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0 4px 10px rgba(0,0,0,0.3);
  transition: background 0.2s;
}

.btn-cerrar:hover {
  background: #d87da8;
}

@keyframes zoomInModal {
  from { opacity: 0; transform: scale(0.85); }
  to { opacity: 1; transform: scale(1); }
}

.fade-modal-enter-active,
.fade-modal-leave-active {
  transition: opacity 0.3s ease;
}

.fade-modal-enter-from,
.fade-modal-leave-to {
  opacity: 0;
}

/* ==========================================
   5. CAPA DE MARIPOSAS Y MÁSCARA
   ========================================== */
.mariposas-layer {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 1;
}

.mariposa-img {
  position: absolute;
  height: auto;
  opacity: 1;
  animation: aleteoSutil 1.8s infinite ease-in-out alternate;
  will-change: transform;
}

@keyframes aleteoSutil {
  0% { transform: scaleX(1); }
  100% { transform: scaleX(0.65); }
}

.mascara-sub-monio-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin-top: -85px;
  margin-bottom: 30px;
  z-index: 4;
}

.mascara-sub-monio-img {
  width: 140px;
  height: auto;
  filter: drop-shadow(0px 4px 8px rgba(0, 0, 0, 0.15));
}

.referencia-esquina-derecha {
  position: absolute;
  bottom: 15px;
  right: 20px;
  font-size: 0px;
}

.letra-especial1 {
  font-family: 'Great Vibes', cursive;
}
.letra-great-vibes {
  font-family: 'corinthia', cursive;
  font-size: 75px;
}
</style>